let _ = t => t,
  _t,
  _t2,
  _t3;
import styled from 'styled-components';
import { styledIf, rotate, colors } from '@ovpn-ui/styles';
import { LayerIndex } from '../../constants';
import { sidebarAnimation, sidebarWidth, closedSidebarWidth } from '../Sidebar.constants';
export const SidebarToggle = styled.div(_t || (_t = _`
    position: absolute;

    top: 32px;
    right: -12px;

    z-index: ${0};

    display: flex;
    justify-content: center;

    width: 24px;
    height: 24px;

    color: ${0};

    background-color: ${0};
    border-radius: 2px;
    cursor: pointer;
    opacity: 0;

    transition: opacity ${0};

    will-change: opacity;

    svg {
        display: block;
        margin: auto;
        ${0};
    }

    &:hover {
        background: ${0};
    }
`), LayerIndex.Sidebar + 1, colors.neutralTextBody, colors.neutralLight, sidebarAnimation, rotate(-90, 90), colors.neutralBorder);
export const SidebarPanel = styled.div(_t2 || (_t2 = _`
    position: fixed;
    top: var(--sidebar-top-offset, 0px);
    bottom: 0;
    left: 0;
    z-index: ${0};

    flex: 0 0 auto;
    width: ${0}px;

    overflow-y: visible;

    background-color: ${0};

    border-right: 1px solid ${0};

    transition: width ${0};

    will-change: width;

    &:hover {
        ${0} {
            opacity: 1;
        }
    }

    ${0}
`), LayerIndex.Sidebar, props => props.$open ? sidebarWidth : closedSidebarWidth, t => t.theme.bg, t => t.theme.border, sidebarAnimation, SidebarToggle, styledIf('$mobile')(_t3 || (_t3 = _`
        top: var(--sidebar-top-offset, 0px);
        left: initial;
        right: ${0}%;

        width: 100%;

        border-right: none;

        transition: right ${0};

        will-change: right;
    `), props => props.$open ? 0 : -100, sidebarAnimation));